const config = {
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:3001/api",
};

export default config;
